import {
    // GET_QUIZ_PLAYER_COVER,
    // ANSWER_GAME_QUESTION,
    // GET_NEXT_QUESTION,
    // START_GAME,
    CLEAR_STATISTIC_PREVIEW
} from './constants';
import http from '../../../utils/httpService';
import { getCookie } from '../../../utils/cookieService';
// /api/v1/get-player-cover/{id}

// const requestPlayerQuizCover = id => {
//     const route = `${GET_QUIZ_PLAYER_COVER}/${id}`
//     const body = { uuid_front: getCookie('uuid') }
//     return http.request(route, 'POST', body)
// }
// const requestGameStart = quizID => {
//     const route = `${START_GAME}/${quizID}`
//     const body = { uuid_front: getCookie('uuid') }
//     return http.request(route, 'POST', body)
// }
// const requestQuestionAnswer = (gameID, answerObject) => {
//     const uuid = getCookie('uuid')
//     const body = {
//         uuid_front: uuid,
//         game_id: gameID,
//         answer: answerObject
//     }
//     return http.request(ANSWER_GAME_QUESTION, 'POST', body)
// }
//
// const requestNextQuestion = (gameID) => {
//     const uuid = getCookie('uuid')
//     const body = {
//         uuid_front: uuid,
//         game_id: gameID,
//     }
//     return http.request(GET_NEXT_QUESTION, 'POST', body)
// }

const requestClearStatisticPreview = (gameID) => {
    const uuid = getCookie('uuid');
    const body = {
        uuid_front: uuid,
        game_id: gameID,
    };
    return http.request(CLEAR_STATISTIC_PREVIEW, 'POST', body);
};

export {
    // requestPlayerQuizCover,
    // requestQuestionAnswer,
    // requestNextQuestion,
    // requestGameStart,
    requestClearStatisticPreview
};
